import { Dialog } from '@mui/material';
import AddWorkModelForm from './WorkModelForm';

const ToggleModal = ({
  open,
  toggle,
  viewType,
  setSubmmited,
  workModelData,
  setSnackBarOpen,
  setSnackbarSeverity,
  setSnackBarMessage,
}) => {
  return (
    <Dialog
      open={open}
      keepMounted
      maxWidth="md"
      fullWidth
      scroll="paper"
      onClose={toggle}
      onBackdropClick={() => {return true}}
    >
      <AddWorkModelForm
        open={open}
        toggle={toggle}
        viewType={viewType}
        workModelData={workModelData}
        setSubmmited={setSubmmited}
        setSnackBarOpen={setSnackBarOpen}
        setSnackbarSeverity={setSnackbarSeverity}
        setSnackBarMessage={setSnackBarMessage}
      />
    </Dialog>
  );
};

export default ToggleModal;
